import { useContext } from "react";
import {
	SeshTextChannelData,
	SyncInclusionType,
} from "../../../../../../common/sesh_types";
import { SyncEntity } from "../../../../../../src/entity/Sync";
import { GuildSettingsContext } from "../../guild_settings";

export function SyncInclusionTag(props: { sync: SyncEntity }) {
	const { all_text_channels } = useContext(GuildSettingsContext);

	return props.sync.included_sesh_events === SyncInclusionType.All ? (
		<SyncTagLabel label="all events" />
	) : props.sync.included_sesh_events === SyncInclusionType.Channel ? (
		<SyncTagLabel
			label={`#${
				all_text_channels.find(
					(channel) => channel.id === props.sync.included_channel
				)?.name
			}`}
		/>
	) : props.sync.included_sesh_events === SyncInclusionType.RSVP ? (
		<SyncTagLabel label="RSVP'd events" />
	) : (
		<></>
	);
}

function SyncTagLabel(props: { label: string }) {
	return (
		<span
			className="tag tag-dark-gray max-w-full flex-shrink flex-grow-0 gap-2 sm:max-w-[45%]"
			title={`sesh - ${props.label}`}
		>
			<span className="sesh-text">sesh</span>{" "}
			<span className="has-text-weight-bold truncate">{props.label}</span>
		</span>
	);
}
